window.megaMenuIdle = true;

jQuery(document).ready(function () {
	// Enable tooltips for color swatches
	tippy('[data-tippy-content]', {
		placement: 'bottom'
	});

	// Sticky Header
	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 0) {
			$('header').addClass('site-header--sticked-top');
		} else {
			$('header').removeClass('site-header--sticked-top');
		}
	});

	// Scroll to next section
	$('.scroll-down-cta').on('click', function (event) {
		event.preventDefault();
		var target = $(this).closest('.shopify-section').next().attr('id');
		scrollToPos('#' + target, 76);

	});

	// navigate to data-link on mega menu item click
	$('.js-mega-menu-item').on('click', function (event) {
		event.preventDefault();
		window.location = this.dataset.link;
	});

	// Hero Slider
	$('.hero .hero-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		rows: 0,
		autoplay: true,
		autoplaySpeed: 5000,
	});

  	$('.showroom .showroom-slider').slick({
		infinite: true,
        centerMode: true,
        centerPadding: '40px',
		slidesToShow: 1.5,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		rows: 0,
		autoplay: true,
		autoplaySpeed: 10000,
      		responsive: [{
				breakpoint: 1030,
				settings: {
					slidesToShow: 1.5,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	// Collections Slider
	$('.collections-slider').slick({
		infinite: false,
		slidesToShow: 4.5,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		rows: 0,
		responsive: [{
				breakpoint: 1030,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	// Related Products Slider
	$('.related-products-slider').slick({
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		rows: 0,
		responsive: [{
				breakpoint: 1030,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	// Testimonials Slider
	$('.testimonials__slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		rows: 0,
	});

	// Field Notes Slider
	var fieldNotesSlideCounter = $('.field-notes .slides-counter');
	$('.field-notes .field-notes-slider').each(function (i, slider) {
		const $slider = $(slider);

		$slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			$slider.closest('.field-notes').find('.current-slide').text(i).next().text(slick.slideCount);
		});

		$slider.slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			rows: 0,
			responsive: [{
					breakpoint: 1030,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	});

	// Blog Posts Gallery Slider
	$('.blog-post-gallery .slider-init').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '380px',
		arrows: true,
		dots: false,
		rows: 0,
		responsive: [{
				breakpoint: 1440,
				settings: {
					centerPadding: '100px',
				}
			},
			{
				breakpoint: 767,
				settings: {
					centerPadding: '50px',
				}
			}
		]
	});

	// Magnific Popup init
	$('.mp-video').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});

    // PDF MFP Trigger
    $('.pdf-mfp-popup').magnificPopup({
        type: 'image',
    });
    
	// Select2 Init
	$('.select-picker').select2({
		minimumResultsForSearch: -1
	});

	// Product Description Slider
	var productDescriptionSlideCounter = $('.product-description .slides-counter');
	var $productDescriptionSlider = $('.product-description .product-slider__init');

	$productDescriptionSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		var i = (currentSlide ? currentSlide : 0) + 1;
		productDescriptionSlideCounter.find('.current-slide').text(i);
		productDescriptionSlideCounter.find('.total-slides').text(slick.slideCount);
	});

	$productDescriptionSlider.slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		rows: 0,
	});
    
 

  
  function myFunction(x) {
    if (x.matches) { // If media query matches

    } else {
      // Jquery Zoom Init
      $('.product-zoom').zoom();
    }
  }
  
  var x = window.matchMedia("(hover: none) and (pointer: coarse) ")
  myFunction(x) // Call listener function at run time
  x.addListener(myFunction) // Attach listener function on state changes
  
  


    // Zoom Icon toggle on hover
    $(".product-slider__init .slide-item").on({
        mouseenter: function () {
            $(this).closest('.product-slider__inner').find('.zoom-cursor').hide();
        },
        mouseleave: function () {
            $(this).closest('.product-slider__inner').find('.zoom-cursor').show();
        }
	});



	// Handle Dropdown Menu click inside propagation
	$(document).on('click', '.dropdown-menu', function (e) {
		e.stopPropagation();
	});

	$('.shop-mega-menu [data-toggle="tab"]').on('mouseenter', function () {
		if (!window.megaMenuIdle) {
			return false;
		}

		window.megaMenuIdle = false;
		const $this = $(this);

		$this.tab('show');

		setTimeout(function () {
			window.megaMenuIdle = true;
		}, 250);
	});

	// Klaviyo form sign-up
	$('.klaviyo-form').on('submit', function (event) {
		event.preventDefault();

		const $form = $(this);
		const g = $form.find('input[name="g"]').val();
		const $fields = $form.find('input[name="$fields"]').val();
		const $source = $form.find('input[name="$source"]').val();
		const $submit = $form.find(':submit');
		const $message = $form.find('.form-notice');
		const $formInner = $form.find('.form-inner');

		let data = {
			"g": g,
			"$fields": $fields,
			"$source": $source
		};

		$form.find('input:not([type=hidden]:not(.btn), textarea').each(function (i, input) {
			const $input = $(input);
			data[$input.attr('name')] = $input.val();
		});

		$submit.attr('disabled', true).val('PLEASE WAIT...');
		$message.empty().removeClass('text-danger').hide();

		$.ajax({
			"async": true,
			"crossDomain": true,
			"url": $form.data('ajax-action'),
			"method": "POST",
			"headers": {
				"content-type": "application/x-www-form-urlencoded",
				"cache-control": "no-cache"
			},
			"data": data,
			success: function (response) {
				$formInner.fadeOut(250, function () {
					$message.html($form.data('success-message')).show();
				});
			},
			error: function (error) {
				if (error.responseJSON.errors[0] == 'Form is invalid.') {
					// We assume that the form is available but it's a duplicate subscription
					$formInner.fadeOut(250, function () {
						$message.html($form.data('success-message')).show();
					});
				} else {
					$message.text('There was an error processing your request. Please try again.').show().addClass('text-danger');
				}
			}
		}).done(function () {
			$submit.removeAttr('disabled').val('SUBSCRIBE');
		});

	});

	// Product image change on color swatch  click
	$('.product-option input[name="option-color"]').on('change', function () {
		if (!this.checked) {
			return false;
		}

		var title = $(this).next().attr('title');

		// instead of going through all ".slider-item img" and checking it's src using JS, you could simply do this
// 		var $targetSlide = $slider.find('.slide-item[data-alt*="' + title + '"]');
      
		var $targetSlide = $('.swiper.prod-images').find('.swiper-slide' + `[data-alt='${title}']`);
		console.log($targetSlide)
		
		if ($targetSlide.length) {
			var index = 
			window.prod_swiper.slideTo($targetSlide.data('index'))
			return true;
		}
      


// 		if ($targetSlide.length) {
// 			$targetSlide = $targetSlide.first();
// 			$slider.slick('slickGoTo', parseInt($targetSlide.data('index')));
// 		}
	});
    const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  
  if(urlParams){
    const url_variant = urlParams.get('variant');
    console.log(url_variant)
	
    var pathArray = window.location.pathname.split('/');
   
    console.log(pathArray)
    

      if (pathArray[1] == "products") {
        console.log("this is a product");

		var thumb_swiper = new Swiper(".swiper.thumbs", {
        	spaceBetween: 10,
        	slidesPerView: 4,
        	freeMode: true,
        	watchSlidesProgress: true,
      	});
		window.prod_swiper = new Swiper(".prod-images", {
			spaceBetween: 10,
			navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
			},
			thumbs: {
				swiper: thumb_swiper,
			},
		});
        
      } else {
        console.log("this is not a product it is a " + pathArray[1]);
      }
  }
});


// Show correct variant image on load
$(window).on('load', function () {


});

// Slick Resize on orientation change
$(window).on('load', function () {
	handleDropdownToggle();

	$(window).on('resize orientationchange', function () {
		$('.slick-initialized').slick('resize');
		handleDropdownToggle();
	});
});

function handleDropdownToggle() {
	if ($(window).width() > 767) {
		$('.dropdown').hover(
			function () {
				const $this = $(this);
				$this.addClass('show');
				$this.find('.dropdown-toggle').attr('aria-expanded', 'true');
				$this.find('.dropdown-menu').addClass('show');
			},
			function () {
				const $this = $(this);
				$this.removeClass('show');
				$this.find('.dropdown-toggle').attr('aria-expanded', 'false');
				$this.find('.dropdown-menu').removeClass('show');
			}
		);
	} else {
		$('.dropdown').off('mouseenter mouseleave');
	}
}

function scrollToPos(target, offset) {
	offset = (typeof offset == 'number') ? offset : 0;
	$("html, body").animate({
		scrollTop: $(target).offset().top - offset
	}, 700);
}